<template>
<div>
    <!-- 退款按钮 -->
	<div class="right">
        <van-button type="primary" size="small" class="buybar__btn right" @click.prevent="refundshow=true">同意退款</van-button>
        <van-button type="default" size="small" class="buybar__btn right mrm" @click.prevent="refuseshow=true">驳回</van-button>         
    </div>
    <!-- 同意退款 -->
    <van-dialog
        v-model="refundshow"
        title="退款"
        show-cancel-button
        confirm-button-text="同意"
        :before-close="refundTrue"
        >
        <van-field
            class="mtm"
            v-model="price"
            @keydown="handleInput2"
            type="number"
            label="退款金额："
            placeholder="请输入金额"
        />  
        <div class="van-cell fs1 ptn red">同意后，退款将自动完成，用户支付资金将按支付方式原路返回。</div>      
    </van-dialog>
    <!-- 驳回退款 -->
    <van-dialog
        v-model="refuseshow"
        title="驳回退款"
        show-cancel-button
        confirm-button-text="确认驳回"
        :before-close="refundFalse"
        >
        <van-field
            v-model="note"
            class="mtm"
            type="text"
            placeholder="请输入驳回原因"
        />
    </van-dialog>
</div>
</template>
<script>
import Vue from 'vue'
import { Toast,Dialog } from 'vant';
Vue.use(Toast).use(Dialog)
export default {
    inject:['reload'],  //注入reload方法
    name: 'TheRefundbar',
    props: {
      totalPrice:{
        // type: Number,
        default:0,
        required: true
      },
      orderId:{
        type: Number,
        default:0,
        required: true
      },
      status:{
        type:String,  //接收订单状态 用来改父组件的状态
      }
    },	
	data(){
		return {
            price:this.totalPrice,
            note:'',
            refundshow:false,  //退款弹框
            refuseshow:false,  //驳回弹框

		}
    },
    methods:{
        refundTrue:function(action, done){           
            //退款
            if (action === 'confirm') {
                if(!this.price || this.price==0){
                    Toast.fail({
                        message:'请输入退款金额！',
                        duration:1000
                    })
                    setTimeout(done(false), 500)
                }else if(this.price>this.totalPrice){
                   Toast.fail({
                        message:'超出最大退款金额！',
                        duration:1000
                    })
                    setTimeout(done(false), 500) 
                }else{
                    this.$http.post('order_manage/auditRefund',{
                        id: this.orderId,
                        audit:true,
                        note:'',
                        amount:this.price,
                    }).then(res => {  
                        if(!res.data.code){
                            // this.order.status = 'refunded'
                            Toast('已退款')
                            this.$emit("statusChanged","refunded")
                            setTimeout(done, 500)
                        }else{
                            Toast.fail(res.data.message)
                            setTimeout(done, 500)
                        }
                    })
                }                
            } else {
                done();
            }
        },
        refundFalse:function(action, done){
            //驳回退款
            if (action === 'confirm') {                
                this.$http.post('order_manage/auditRefund',{
                    id: this.orderId,
                    audit:false,
                    note:this.note,
                }).then(res => { 
                    if(!res.data.code){
                        Toast('已驳回')
                        // this.order.status = 'paid'
                        this.$emit("statusChanged","paid")  //修改父组件的状态值
                        setTimeout(done, 500)
                        // this.reload()
                    }else{
                        Toast.fail(res.data.message)
                        setTimeout(done, 500)
                    }
                })              
            } else {
                done();
            }
        },
        handleInput2(e) {
            // 通过正则过滤小数点后两位
            e.target.value = (e.target.value.match(/^\d*(\.?\d{0,1})/g)[0]) || null   
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/TheRefundbar.vue